import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_filing_year_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  duration_filing_cycle: fromDatatype.IntegerDatatypeInterface;
  period_method: fromDatatype.VarcharDatatypeInterface;
  start_year: fromDatatype.IntegerDatatypeClass;
  start_month: fromDatatype.IntegerDatatypeClass;
  end_year: fromDatatype.IntegerDatatypeClass;
  end_month: fromDatatype.IntegerDatatypeClass;
  descr: fromDatatype.TextDatatypeInterface
  state: fromDatatype.VarcharDatatypeInterface;
  batch: fromDatatype.VarcharDatatypeInterface;
  approval: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_filing_year_hdr_RowClass
  implements bl_fi_filing_year_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
    duration_filing_cycle: fromDatatype.IntegerDatatypeInterface;
    period_method: fromDatatype.VarcharDatatypeInterface;
    start_year: fromDatatype.IntegerDatatypeClass;
    start_month: fromDatatype.IntegerDatatypeClass;
    end_year: fromDatatype.IntegerDatatypeClass;
    end_month: fromDatatype.IntegerDatatypeClass;
    descr: fromDatatype.TextDatatypeInterface
    state: fromDatatype.VarcharDatatypeInterface;
    batch: fromDatatype.VarcharDatatypeInterface;
    approval: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
